import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import submit from "submit-form";

const CreateChat = ({ locals, cycleId }) => {
  const { t } = useTranslation("coaching-portal");
  const { editCycle } = locals;

  return (
    <Modal
      className={"publish-team-modal"}
      header={false}
      toClear={["cycleId"]}
    >
      <div className="body">
        <h2 className="mb-4 text-center">{t("teams.createChat.title")}</h2>

        <p>{t("teams.createChat.intro")}</p>
      </div>

      <footer id="confirmation-modal-footer">
        <button
          data-button-type="secondary"
          onClick={() => {
            submit(`/actions/refresh?`, {
              method: "GET",
              body: {
                "modal[type]": "",
                cycleId: "",
                cycleName: "",
              },
            });
          }}
        >
          <span>{t("teams.createChat.cancel")}</span>
        </button>
        <button
          data-button-type={"primary"}
          onClick={() => {
            submit(`/actions/cycle/create-chat/${cycleId}?`, {
              method: "POST",
              body: {
                subject: editCycle.name,
                guests: [],
              },
            });
          }}
        >
          {t("teams.createChat.publish")}
        </button>
      </footer>
    </Modal>
  );
};

export default CreateChat;
